import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar.jsx';
import { Topbar } from './Topbar.jsx';
import { ShiftModals } from '../features/shifts/components/ShiftModals.jsx';

export function Shell() {
  return (
    <div className="grid min-h-screen bg-paper" style={{ gridTemplateColumns: '248px 1fr' }}>
      <Sidebar />
      <main className="min-w-0">
        <Topbar />
        <div className="px-7 py-5 pb-16 max-w-[1400px]">
          <Outlet />
        </div>
      </main>
      {/* نوافذ فتح/إقفال/تقرير الشفت — متاحة من أي شاشة */}
      <ShiftModals />
    </div>
  );
}
